module.exports = __webpack_public_path__ + "img/iot1.3024868f.png";